import { createNamespacer, createReducer } from "../utils/reducers";

const namespacer = createNamespacer("SUPPORT");

const initialState = {
  adminSupportCount: 0,
  adminSupportIndicator: false,
  adminSupportRefresh: false,
};

const handlers = {
  [namespacer("INITIALIZE_ADMIN_SUPPORT_COUNT")]: (state: any, action: any) => {
    return {
      ...state,
      adminSupportCount:  action.payload?.count,
      adminSupportIndicator: false,
    };
  },
  [namespacer("SET_ADMIN_SUPPORT_COUNT")]: (state: any, action: any) => {
    return {
      ...state,
      adminSupportCount:  action.payload?.count,
      adminSupportIndicator: action.payload?.count > state.adminSupportCount ? true : state.adminSupportIndicator,
    };
  },
  [namespacer("SET_ADMIN_SUPPORT_INDICATOR")]: (state: any, action: any) => {
    return {
      ...state,
      adminSupportIndicator: action.payload?.value,
    };
  },
  [namespacer("REFRESH_ADMIN_SUPPORT_PAGE")]: (state: any, action: any) => {
    return {
      ...state,
      adminSupportRefresh: state.adminSupportIndicator ? action.payload?.value : false,
    };
  },
};

const search = createReducer(initialState, handlers, ["SUPPORT"]);

export default search;
